import React from 'react';
import styles from './MenuItem.css';

function MenuItem(props) {
  const { title, onClick, back } = props;
  return (
    <div className={styles['menu-container']}>
      <p
        className={`${styles['menu-item-title']} ${back &&
          styles['icon-back']}`}
        onClick={back && onClick}
        data-testid="menu-item-title"
      >
        {title}
      </p>
    </div>
  );
}

export default MenuItem;
